module.exports = __webpack_public_path__ + "static/media/9.b281b8ec.jpg";